// angular
//   .module('HeroPRO')
//   .directive('dropzone', dropzone);

/* @ngInject */
export default function dropzone(HPConfig, $rootScope, DropzoneFactory, AuthenticationFactory, TempDocumentFactory) {
    return {
        restrict: 'C',
        scope: {
            dropzoneFormDataField: '@',
            dropzoneFormData: '=?',
            dropzoneUrl: '@',
            dropZoneMaxFileSize: '=',
            dropzoneAcceptedFiles: '@',
        },
        link(scope, element) {
            // console.log("scope.dropzoneUrl",scope.dropzoneUrl);
            const dropzoneUrl = (scope.dropzoneUrl === null || scope.dropzoneUrl === undefined) ? 'DocumentManagement/UploadAttachment' : scope.dropzoneUrl;
            const dropzoneAcceptedFiles = (scope.dropzoneAcceptedFiles === null || scope.dropzoneAcceptedFiles === undefined) ? '.pdf,.jpg,.jpeg,.png,.gif,.tif,.bmp,.doc,.docx,.ppt,.pptx' : scope.dropzoneAcceptedFiles;
            const dropzoneMaxFileSize = (scope.dropZoneMaxFileSize === null || scope.dropZoneMaxFileSize === undefined) ? 10 : scope.dropZoneMaxFileSize;

            const config = {
                url: HPConfig.heroProApi + dropzoneUrl,
                paramName: 'uploadfile',
                uploadMultiple: false,
                addRemoveLinks: true,
                maxThumbnailFilesize: 10,
                parallelUploads: 1,
                withCredentials: false,
                maxFilesize: dropzoneMaxFileSize, // in MB
                acceptedFiles: dropzoneAcceptedFiles,
                method: 'PUT',
                accept(file, done) {
                    TempDocumentFactory.generateTempDocument(file.name)
                        .then((response) => {
                            file.uploadURL = response.data.Data.PreSignedUploadUrl;
                            file.downloadUrl = response.data.Data.DownloadUrl;
                            file.tempFileKey = response.data.Data.TempFileKey;
                            done();
                        })
                        .catch(() => {
                            done('Error obtaining temporary upload url.');
                        });
                },
                // autoProcessQueue: false,
                // createImageThumbnails: false,
                // clickable: false,
                // dictDefaultMessage: 'Click or Drop files here to upload.'
            };

            const dropzone = new DropzoneFactory(element[0], config);

            const eventHandlers = {
                addedfile(file) {
                    scope.file = file;
                    // Ignored if condition below has to be != and NOT !==
                    /* jshint ignore:start */
                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }
                    /* jshint ignore:end */
                    scope.$apply(() => {
                        scope.fileAdded = true;
                    });
                },

                removedfile() {
                    $rootScope.$broadcast('HPFileRemoved');
                },

                success(file, response) {
                    // console.log('success');
                    $rootScope.$broadcast('HPFileUploaded', response, file);
                },

                error() {
                    // 'error': function (file, errorMessage ,xhr ) {
                    // console.log(errorMessage , xhr);
                },

                sending(file, request) {
                    request.setRequestHeader('x-amz-server-side-encryption', 'AES256');
                    request.setRequestHeader('Content-Type', file.type);
                    const _send = request.send;
                    request.send = function () {
                        _send.call(request, file);
                    };
                    $rootScope.$broadcast('HPFileUploading');
                },

                processing(file) {
                    dropzone.options.url = file.uploadURL;
                    $rootScope.$broadcast('HPFileProcessing');
                },
            };

            angular.forEach(eventHandlers, (handler, event) => {
                dropzone.on(event, handler);
            });

            scope.processDropzone = function () {
                dropzone.processQueue();
            };

            scope.resetDropzone = function () {
                dropzone.removeAllFiles();
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/dropzoneDirective.js